import {
  LogInSchoolID,
  LogInUserID,
  userTimeZone,
  normalizeToSnakeCase,
  BaseUrl,
  handleUnauthorized
} from "./Common";
import { log } from "./Logger";
import { store } from "../Store/Store";
export var TenantFlag = "rocket-k12";
export function setTenantFlag(flag) {
  TenantFlag = flag;
}

var authkey = process.env.REACT_APP_AuthKey;
const CDNUrL = `${BaseUrl}/files`;

async function handleValidationError(response) {
  const responseStatuses = [422];
  if (!responseStatuses.includes(response?.status)) return null;
  const result = await response.text();
  try {
    const parsed = JSON.parse(result);
    alert(parsed?.message || "Validation error occurred. Please check your input.");
  } catch {
    alert(result || "Validation error occurred. Please check your input.");
  }
  return result;
}

function normalizeAuthorizationHeader(token) {
  if (!token || typeof token !== "string") return null;
  return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
}

function getJwtTokenFromPersistedState() {
  try {
    const persistedRoot = localStorage.getItem("persist:root");
    if (!persistedRoot) return null;
    const parsedRoot = JSON.parse(persistedRoot);
    const authDataRaw = parsedRoot?.authData;
    if (!authDataRaw) return null;
    const authData =
      typeof authDataRaw === "string" ? JSON.parse(authDataRaw) : authDataRaw;
    return authData?.cipherText || null;
  } catch {
    return null;
  }
}

function getJwtToken() {
  const stateToken = store?.getState?.()?.authData?.cipherText;
  return stateToken || getJwtTokenFromPersistedState();
}

export function appendJwtAuthorization(headers) {
  const jwtToken = getJwtToken();
  const authorization = normalizeAuthorizationHeader(jwtToken);
  if (authorization) {
    headers.set("Authorization", authorization);
  }
}


function getUserIdFromPersistedState() {
  try {
    const persistedRoot = localStorage.getItem("persist:root");
    if (!persistedRoot) return null;
    const parsedRoot = JSON.parse(persistedRoot);
    const authDataRaw = parsedRoot?.authData;
    if (!authDataRaw) return null;
    const authData =
      typeof authDataRaw === "string" ? JSON.parse(authDataRaw) : authDataRaw;
    return authData?.userId || null;
  } catch {
    return null;
  }
}

export function getUserId() {
  const stateUserId = store?.getState?.()?.authData?.userId;
  return stateUserId || getUserIdFromPersistedState();
}

export function ApiGetCall(endpoint, signal = null, skipNormalize = false) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("usertimezone", userTimeZone || "America/New_York");
  myHeaders.append("Login", TenantFlag);
  myHeaders.append("userid", getUserId());
  appendJwtAuthorization(myHeaders);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
    credentials: "include",
    ...(signal != null && { signal: signal }),
  };
  return fetch(`${BaseUrl}${endpoint}`, requestOptions)
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      return response.text();
    })
    .then((result) => {
      if (!result) return result;

      try {
        const parsed = JSON.parse(result);

        if (skipNormalize) {
          return result;
        }
        const normalized = normalizeToSnakeCase(parsed);

        return JSON.stringify(normalized);
      } catch {
        return result;
      }
    })
    .catch((error) => {
      log.error(error);
    });
}

export async function ApiPostCall(endpoint, payload, skipSnake = false) {

  const apiPostCallHeaders = new Headers();
  apiPostCallHeaders.append("Content-Type", "application/json");
  apiPostCallHeaders.append("usertimezone", userTimeZone || "America/New_York");
  apiPostCallHeaders.append("userid", getUserId());
  apiPostCallHeaders.append("Login", TenantFlag);
  appendJwtAuthorization(apiPostCallHeaders);

  const requestOptions = {
    method: "POST",
    headers: apiPostCallHeaders,
    body: payload,
    redirect: "follow",
    credentials: "include",
  };

  return await fetch(`${BaseUrl}${endpoint}`, requestOptions)
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then((result) => {
      if (!result) return result;
      try {
        const parsed = JSON.parse(result);
        const normalized = skipSnake ? parsed : normalizeToSnakeCase(parsed);
        return JSON.stringify(normalized);
      } catch {
        return result;
      }
    })
    .catch((error) => {
      log.error("Fetch error:", error);
    });
}

export function ApiGetCallAuthKey(endpoint, signal = null) {
  var myHeadersAuthToken = new Headers();
  myHeadersAuthToken.append("Content-Type", "application/json");
  myHeadersAuthToken.append("Login", TenantFlag);
  myHeadersAuthToken.append("usertimezone", userTimeZone || "America/New_York");
  myHeadersAuthToken.append("Authorization", authkey);
  myHeadersAuthToken.append("userid", getUserId());
  // appendJwtAuthorization(myHeadersAuthToken);
  var requestOptions = {
    method: "GET",
    headers: myHeadersAuthToken,
    redirect: "follow",
    credentials: "include",
    ...(signal != null && { signal: signal }),
  };
  return fetch(`${BaseUrl}${endpoint}`, requestOptions)
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      return response.text();
    })
    .then((result) => {
      if (!result) return result;
      try {
        const parsed = JSON.parse(result);
        const normalized = normalizeToSnakeCase(parsed);
        return JSON.stringify(normalized);
      } catch {
        return result;
      }
    })
    .catch((error) => {
      log.error(error);
    });
}

export async function ApiPostCallAuthKey(endpoint, payload) {

  const apiPostCallAuthKey = new Headers();
  apiPostCallAuthKey.append("Content-Type", "application/json");
  apiPostCallAuthKey.append("usertimezone", userTimeZone || "America/New_York");
  apiPostCallAuthKey.append("Login", TenantFlag);
  apiPostCallAuthKey.append("Authorization", authkey);
  apiPostCallAuthKey.append("userid", getUserId());
  // appendJwtAuthorization(apiPostCallAuthKey);

  var urlencoded = payload;
  var requestOptions = {
    method: "POST",
    headers: apiPostCallAuthKey,
    body: urlencoded,
    redirect: "follow",
    credentials: "include",
  };
  return await fetch(`${BaseUrl}${endpoint}`, requestOptions)
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      return response.text();
    })
    .then((result) => {
      if (!result) return result;
      try {
        const parsed = JSON.parse(result);
        const normalized = normalizeToSnakeCase(parsed);
        return JSON.stringify(normalized);
      } catch {
        return result;
      }
    })
    .catch((error) => {
      log.error(error);
    });
}

export async function ApiPostLoginCall(endpoint, payload, useAuthKey = false) {
  const loginHeaders = new Headers();
  loginHeaders.append("Content-Type", "application/json");
  loginHeaders.append("usertimezone", userTimeZone || "America/New_York");
  loginHeaders.append("Login", TenantFlag);
  if (useAuthKey) {
    loginHeaders.append("Authorization", authkey);
  }

  const requestOptions = {
    method: "POST",
    headers: loginHeaders,
    body: payload,
    redirect: "follow",
    credentials: "include",
  };

  return await fetch(`${BaseUrl}${endpoint}`, requestOptions)
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return { body: validationResult, headers: { authorization: response.headers.get("Authorization") } };
      if (!response.ok) {
        alert("Something went wrong on the server. Please try again later.");
        window.location.reload();
      }
      const authorization = response.headers.get("Authorization");
      return response.text().then((body) => ({ body, authorization }));
    })
    .then((result) => {
      if (!result) return result;
      try {
        const parsed = JSON.parse(result.body);
        const normalized = normalizeToSnakeCase(parsed);
        return {
          data: JSON.stringify(normalized),
          headers: {
            authorization: result.authorization,
          },
        };
      } catch {
        return {
          data: result.body,
          headers: {
            authorization: result.authorization,
          },
        };
      }
    })
    .catch((error) => {
      alert("Something went wrong on the server. Please try again later.");
      window.location.reload();
      log.error("Login fetch error:", error);
    });
}

// Api Call for Graph's in Admin and School Dashboard
export const fetchAdminData = async (
  endpoint,
  dataKey,
  setAllData,
  signal = null,
) => {
  setAllData((prevState) => ({
    ...prevState,
    [dataKey]: { ...prevState?.[dataKey], data: [], loader: true },
  }));
  try {
    const result = await ApiGetCall(endpoint, signal);
    if (result == undefined || result == "") {
      log.error("Something went wrong");
    } else {
      const responseRs = JSON.parse(result);
      const snakeKey = dataKey
        .replace(/([A-Z])/g, "_$1")
        .replace(/__/g, "_")
        .replace(/^_/, "")
        .toLowerCase();
      const actualData =
        responseRs[snakeKey] !== undefined
          ? responseRs[snakeKey]
          : responseRs[dataKey];
      setAllData((prevState) => ({
        ...prevState,
        [dataKey]: {
          ...prevState?.[dataKey],
          data: actualData,
          loader: false,
        },
      }));
      return result;
    }
  } catch (error) {
    setAllData((prevState) => ({
      ...prevState,
      [dataKey]: { ...prevState?.[dataKey], data: [], loader: false },
    }));
    log.error(error);
  }
};

// Api Call for Grid Headers Dynamically
export async function ApiGetHeaders(
  gridid,
  setColumnNames,
  flag,
  adminSchoolId,
) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("usertimezone", userTimeZone || "America/New_York");
  myHeaders.append("Login", TenantFlag);
  myHeaders.append("Authorization", authkey);
  myHeaders.append("userid", getUserId());
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
    credentials: "include",
  };
  var SchoolID = null;
  if (flag == 1) {
    SchoolID = adminSchoolId;
  } else {
    SchoolID = LogInSchoolID;
  }
  return await fetch(
    `${BaseUrl}/grid-headers?gridId=${gridid}&userId=${LogInUserID}&schoolId=${SchoolID}`,
    requestOptions,
  )
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      return response.text();
    })
    .then((result) => {
      const parsed = JSON.parse(result);
      const responseRs = normalizeToSnakeCase(parsed);
      const columns = responseRs?.msg?.split("~");
      setColumnNames(columns);
    })
    .catch((error) => {
      log.error(error);
    });
}

export function ApiGetCDNData(endpoint, schoolNo, schoolID) {
  var uniqueId;
  if (LogInSchoolID || LogInSchoolID == 0) {
    uniqueId = LogInSchoolID == 0 ? "00" : LogInSchoolID;
  } else if (schoolID || schoolID == 0) {
    uniqueId = schoolID == 0 ? "00" : schoolID;
  } else {
    uniqueId = "00";
  }

  var CDNHeaders = new Headers();
  CDNHeaders.append("Content-Type", "application/json");
  CDNHeaders.append("Authorization", authkey);
  CDNHeaders.append("usertimezone", userTimeZone || "America/New_York");
  CDNHeaders.append("Login", TenantFlag);
  CDNHeaders.append("Uniqueid", uniqueId);
  CDNHeaders.append("userid", getUserId());
  var requestOptions = {
    method: "GET",
    headers: CDNHeaders,
    redirect: "follow",
    credentials: "include",
  };
  return fetch(
    `${CDNUrL}${endpoint}?school_num=${LogInSchoolID == 0 ? "admin" : schoolNo}`,
    requestOptions,
  )
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      return response.blob();
    })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      log.error(error);
    });
}

// contentFlag  : false = FormData body  | true = JSON body
// authJwtFlag  : false = JWT Token flow | true = Unique Key flow
export function ConfigApiHeaders(headers, contentFlag = false, authJwtFlag = false) {
  if (contentFlag) {
    headers.append("Content-Type", "application/json");
  }
  headers.append("usertimezone", userTimeZone || "America/New_York");
  headers.append("Login", TenantFlag);
  headers.append("userid", getUserId());

  if (authJwtFlag) {
    headers.append("Authorization", authkey);
  } else {
    appendJwtAuthorization(headers);
  }
}

// contentFlag  : false = FormData body  | true = JSON body
// authJwtFlag  : false = JWT Token flow | true = Unique Key flow
export async function ApiCmnHeadersPostCall(endpoint, formDataPayload, contentFlag = false, authJwtFlag = false) {
  const apiComonHeaders = new Headers();
  ConfigApiHeaders(apiComonHeaders, contentFlag, authJwtFlag);

  var requestOptions = {
    method: "POST",
    headers: apiComonHeaders,
    body: formDataPayload,
    credentials: "include",
  };

  return await fetch(`${BaseUrl}${endpoint}`, requestOptions)
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      return response.text();
    })
    .then((result) => {
      if (!result) return result;
      try {
        const parsed = JSON.parse(result);
        return JSON.stringify(parsed);
      } catch {
        return result;
      }
    })
    .catch((error) => {
      log.error(error);
    });
}

// contentFlag  : false = FormData body  | true = JSON body
// authJwtFlag  : false = JWT Token flow | true = Unique Key flow
export function ApiCmnHeadersGetCall(endpoint, snakeCaseFlag = false, contentFlag = false, authJwtFlag = false) {
  var apiComonHeaders = new Headers();
  ConfigApiHeaders(apiComonHeaders, contentFlag, authJwtFlag);

  var requestOptions = {
    method: "GET",
    headers: apiComonHeaders,
    redirect: "follow",
    credentials: "include",
  };

  return fetch(`${BaseUrl}${endpoint}`, requestOptions)
    .then(async (response) => {
      if (handleUnauthorized(response)) return;
      const validationResult = await handleValidationError(response);
      if (validationResult !== null) return validationResult;
      return response.text();
    })
    .then((result) => {
      if (!result) return result;
      try {
        const parsed = JSON.parse(result);
        const normalized = snakeCaseFlag ? normalizeToSnakeCase(parsed) : parsed;
        return JSON.stringify(normalized);
      } catch {
        return result;
      }
    })
    .catch((error) => {
      log.error(error);
    });
}